import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const wakatime = defineConnector({
  identifier: "wakatime",
  name: "WakaTime",
  tagLine: "Developer time tracking",
  logo,
  protocol: "http",
  tags: ["engineering", "productivity"],
  defaultUrlPattern: () => "https://api\\.wakatime\\.com/.*",
  auth: (app) => queryAuth([{ name: "api_key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [WakaTime settings](https://wakatime.com/settings/api-key) and copy your API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.wakatime.com/api/v1/users/current",
  },
});
